// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetStatistics200ResponseVendors
 */
export interface GetStatistics200ResponseVendors {
    /**
     * Distinct vendor count across DTAs
     * @type {number}
     * @memberof GetStatistics200ResponseVendors
     */
    active: number;
}

/**
 * Check if a given object implements the GetStatistics200ResponseVendors interface.
 */
export function instanceOfGetStatistics200ResponseVendors(value: object): value is GetStatistics200ResponseVendors {
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function GetStatistics200ResponseVendorsFromJSON(json: any): GetStatistics200ResponseVendors {
    return GetStatistics200ResponseVendorsFromJSONTyped(json, false);
}

export function GetStatistics200ResponseVendorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatistics200ResponseVendors {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'],
    };
}

export function GetStatistics200ResponseVendorsToJSON(json: any): GetStatistics200ResponseVendors {
    return GetStatistics200ResponseVendorsToJSONTyped(json, false);
}

export function GetStatistics200ResponseVendorsToJSONTyped(value?: GetStatistics200ResponseVendors | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
    };
}
